// Image constants for Dr. Punit Mahajan website

export const IMAGES = {
  logo: 'https://customer-assets.emergentagent.com/job_5b181516-0af6-4b09-9e69-af5104fcf438/artifacts/u0lkoxin_FINAL%20LOGO.png',
  doctor: {
    hero: 'https://customer-assets.emergentagent.com/job_dr-punit-clinic/artifacts/bfbe0dvy_c4fc38d5-52a2-40be-a6e7-950f608d005b.png',
    scrubs1: 'https://customer-assets.emergentagent.com/job_dr-punit-clinic/artifacts/hrtlkh8s_0c214b26-f30d-49bc-83ee-49f728f1800d.png',
    desk1: 'https://customer-assets.emergentagent.com/job_dr-punit-clinic/artifacts/cvqrsag9_0fb490b1-69cc-424f-a746-2e02107d728d.png',
    desk2: 'https://customer-assets.emergentagent.com/job_dr-punit-clinic/artifacts/q5sm6d65_3d0af394-f82c-4a5d-9e67-2300f3d0e421.png',
    formal: 'https://customer-assets.emergentagent.com/job_dr-punit-clinic/artifacts/8pzm0u58_9fa0fe33-e6b2-40ce-8129-bfe08e54038b.png',
    scrubs2: 'https://customer-assets.emergentagent.com/job_dr-punit-clinic/artifacts/slmq4ybq_96bbc0d2-1fc9-4588-b7c9-666757e97fd8.png'
  }
};

export const CONTACT = {
  phone: '+919819215761',
  whatsapp: '+919819215761',
  email: 'drpunit.ir@gmail.com',
  gmb: 'https://share.google/iRXzE4obvO9aPrxh4'
};
